// Business form using Google Forms
function formBusiness() {
    var $form = $('.js-form-plan-business'),
        $submit_button = $('.js-form-plan-business-submit'),
        $response = $('.js-form-business-response'),
        form_action = $form.data('action'),
        getDataType = $(this).attr('data-type'),
        form_data = {},
        $modal_title = $('.js-next-modal-title'),
        documentLang = document.querySelector('html').getAttribute('lang');

    $('.js-get-url').val(document.referrer !== "" ? document.referrer : window.location.href);

    $form.find('.form-field').each(function(){
        var that = $(this);
        var getId = $(this).attr('name');
        var getValue = $(this).val();

        if( $(this).hasClass('is-radio') ) {
            form_data[that.data('name')] = that.find('input[type="radio"]:checked').val();
        } else {
            form_data[getId] = getValue;
        }

        if($(this).hasClass('is-checkbox')) {
            var checkboxValue = [];

            $(this).find('input[type="checkbox"]:checked').each(function() {
                checkboxValue.push($(this).val());
            });

            form_data[that.data('name')] = checkboxValue.join();

        } else {
            form_data[getId] = getValue;
        }
    });

    function closeAlert() {
        $response.find('.close').on('click', function(){
            $response.addClass('hide');
        });
    }

    $form.validate({
        rules: {
            'email': { required: true, email: true },
            'cnpj_contact': { required: true, cnpj: true }
        },

        errorElement: 'span',

        submitHandler: function(form){

            form_data = $form.find(':input[name != "csrf_token"]').serializeArray();
            $submit_button.find('.js-loading').removeClass('hide');
            $submit_button.find('.js-default-label').addClass('hide');
            $submit_button.attr('disabled', true);

            // First register user info cookie
            $.ajax({
                url: register_university_user,
                data: form_data,
                type: "POST",
            }).complete(function() {

                // Then, register the form
                $.ajax({
                    url: form_action,
                    data: form_data,
                    type: "POST",
                    dataType: getDataType,
                    crossDomain: true,
                }).complete(function(){

                    setTimeout(function(){
                        $submit_button.attr('disabled', false);
                        $submit_button.find('.js-loading').addClass('hide');
                        $submit_button.find('.js-default-label').removeClass('hide');
                        $form.addClass('hide');
                        $response.removeClass('hide');
                        $modal_title.addClass('hide');

                    }, 1500);

                    hubspotIntegration(form_data, 'businessLanding', function() {
                        hubspotCustomEvents('subscribed_at_business_landing');
                        amplitude_log_event('[Empresarial] Form subscription success');

                        if (LS.langForFields == "es-ar" || LS.langForFields == "pt-br") {
                            var gmvValue = LS.langForFields == "pt-br" ?
                                document.getElementsByName('gmv')[0].value :
                                document.getElementById('user-gmv').value,
                                isClient = document.getElementsByName('contact_is_client')[0].value

                            handleSuccessByGmv(gmvValue, isClient)

                            window.dataLayer.push({
                                'event': 'mmSubscribeData',
                                form_data
                            })
                        }
                    });
                });
            })

            closeAlert();
            adsEvent();
        }
    });
}

formBusiness();

function adsEvent() {
    var findParams = new URLSearchParams(window.location.search);

    if(findParams.get('utm_campaign') && $('.js-form-tracking').length && typeof gtag == 'function') {
        gtag('event', 'conversion', {'send_to': 'AW-991255581/L2G8CJze-KIBEJ241dgD'});
    }
}


$('#modal-empresarial').on('show.bs.modal', function (e) {
    $('.js-form-plan-business').find('input').first().focus();
});

$('#modal-empresarial').on('hidden.bs.modal', function (e) {
    $('.js-form-plan-business').removeClass('hide');
    $('.js-form-business-response').addClass('hide');
});

// Conditional form for business contact
var $field_contional = $('.js-conditional'),
    $field_conditional_input = $field_contional.find('input');

$field_conditional_input.on('change', function() {
    var condition_id = $(this).data('condition');
    if($(this).hasClass('has_conditional')) {
        $('.js-conditional-field[data-from='+condition_id+']').removeClass('hide').find('.form-control').prop('required', true);
    } else {
        $('.js-conditional-field[data-from='+condition_id+']').addClass('hide').find('.form-control').removeAttr('required');
    }
});


function handleSuccessByGmv(gmv, isClient) {
    window.VWO = window.VWO || [];
    window.VWO.push(['track.goalConversion',38]);

    var showIsClient = '';

    if (isClient == "Sim" || isClient) {
        var showIsClient = '_is_client'
    }

    if (gmv == 'high-sales' || gmv == 'huge-sales' || gmv == 'huge-sales-plus' ||gmv == 'Entre $4.000.000 y $6.000.000' || gmv == 'Más $6.000.000') {
        window.location = encodeURI(track_mql_url + '?redirect_to=' +  next_url + '?show_success=true' + showIsClient);
        return
    }

    return
}
